module.exports = __webpack_public_path__ + "static/cloud-people-826a346e0f3272fdea2fc47cca8c1ec3.jpg";